<template>
  <div>
    <vx-card class="w-full mb-6">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/4 w-full">
          <label>From Date</label>
          <datepicker
            ref="fromPicker"
            v-model="fromDate"
            :inline="false"
            :format="format"
          ></datepicker>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label>To Date</label>
          <datepicker
            ref="fromPicker"
            v-model="toDate"
            :inline="false"
            :format="format"
          ></datepicker>
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label>Domain</label>
          <v-select
            placeholder="Search / Select Domain"
            v-model="selectedDomain"
            :options="domainList"
          ></v-select>
        </div>
        <div
          style="align-items: center; display: flex; justify-content: center"
          class="vx-col sm:w-1/4 w-full"
        >
          <vs-button style="" ref="search" @click="searchForData">
            <strong>Search</strong>
          </vs-button>
        </div>
      </div>
      <div class="flex justify-center" v-if="reportData.length > 0">
        <div
          style="align-items: center; display: flex; justify-content: center"
          class="vx-col sm:w-1/4 w-full"
        >
          <vs-button
            :disabled="isDownloading"
            ref="downloadReport"
            @click="dowloadReportDataCSV"
          >
            <div class="flex justify-center items-center">
              <strong class="mr-2">Download Report</strong>
              <feather-icon icon="DownloadIcon" svgClasses="h-8 w-8" />
            </div>
          </vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Subscriptions</h2>
            <chartjs-doughnut-chart
              :data="pieChartdata"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Race</h2>
            <chartjs-doughnut-chart
              :data="racePieChartData"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Transaction Type</h2>
            <chartjs-doughnut-chart
              :data="voucherPieChartData"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Provinces</h2>
            <chartjs-doughnut-chart
              :data="provincePieChartData"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Verified</h2>
            <chartjs-doughnut-chart
              :data="verifiedUsersPieChartData"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
          <div>
            <h2 class="text-center">Website</h2>
            <chartjs-doughnut-chart
              :data="registrationPieChartData"
              :options="pieChartoptions"
            ></chartjs-doughnut-chart>
          </div>
        </vx-card>
      </div>
    </div>
    <vx-card v-if="timeSeriesData.length && !isLoading" class="w-full mb-6">
      <div>
        <h2 class="text-center">Subscriptions over time</h2>
        <chartjs-bar-chart
          :options="barChartOptions"
          :data="barChartData"
        ></chartjs-bar-chart>
      </div>
    </vx-card>
    <vx-card class="w-full mb-6" v-if="noData">
      <h1>No Data was Found</h1>
    </vx-card>
  </div>
</template>

<script>
import { get } from "jquery";
import moment from "moment";
import index from "vue-prism-component";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import ChartjsBarChart from "../../components/chart/ChartjsBarChart.vue";
import ChartjsDoughnutChart from "../../components/chart/ChartjsDoughnutChart.vue";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
    ChartjsBarChart,
    ChartjsDoughnutChart,
  },
  data() {
    return {
      format: "yyyy-MM-dd",
      isMounted: false,
      fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      toDate: new Date(),
      domainList: [],
      selectedDomain: null,
      reportData: [],
      timeSeriesData: [],
      barChartOptions: null,
      barChartData: null,
      isLoading: false,
      isDownloading: false,
      registrationPieChartData: {
        labels: [],
        datasets: [],
      },
      verifiedUsersPieChartData: {
        labels: [],
        datasets: [],
      },
      provincePieChartData: {
        labels: [],
        datasets: [],
      },
      voucherPieChartData: {
        labels: [],
        datasets: [],
      },
      racePieChartData: {
        labels: [],
        datasets: [],
      },
      pieChartdata: {
        labels: [],
        datasets: [],
      },
      pieChartoptions: {
        title: {
          display: false,
        },
      },
      noData: false,
      seed: Math.floor(Math.random() * 10000),
    };
  },
  methods: {
    initValues() {
      //Reset all values to default
      this.domainList = [];
      this.selectedDomain = null;
      this.reportData = [];
      this.fromDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      );
      this.toDate = new Date();
      this.noData = false;
    },
    resetValues() {
      var self = this;
      self.registrationPieChartData = {
        labels: [],
        datasets: [],
      };
      self.verifiedUsersPieChartData = {
        labels: [],
        datasets: [],
      };
      self.provincePieChartData = {
        labels: [],
        datasets: [],
      };
      self.voucherPieChartData = {
        labels: [],
        datasets: [],
      };
      self.racePieChartData = {
        labels: [],
        datasets: [],
      };
      self.pieChartdata = {
        labels: [],
        datasets: [],
      };
      self.timeSeriesData = [];
      self.reportData = [];
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    getDomainList() {
      var self = this;
      //self.showLoadingOnElement("generateVouchersButton", 0.45, "material");

      var onSuccess = (response) => {
        //Add All to the first index
        response.data.unshift({ value: null, label: "All" });
        self.domainList = response.data;
        self.selectedDomain = self.domainList[0];
      };

      var onFinally = function () {
        //self.$vs.loading.close(self.$refs.generateVouchersButton.$el);
      };

      self.$ajaxGet(self, "Site/GetDomainList", onSuccess, onFinally);
    },
    searchForData() {
      var self = this;
      self.noData = false;
      self.isLoading = true;
      self.showLoadingOnElement("search", 0.45, "material");
      var onSuccess = (response) => {
        self.reportData = response.data;
        if (!response.data.length) {
          self.noData = true;
          //clear all data
          self.resetValues();

          return;
        }
        self.generateTimeSeriesReport();
        self.getPieChartData();
        self.getRacePieChartData();
        self.getTransactionTypeChartData();
        self.getProvinceChartData();
        self.getVerifiedUsersChartData();
        self.getRegistrationPieChartData();
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.search.$el);
        self.isLoading = false;
      };
      var objToSend = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        domain: self.selectedDomain ? self.selectedDomain.value : null,
      };
      self.$ajaxPost(
        self,
        "CEP/GetTransactionReport",
        objToSend,
        onSuccess,
        onFinally
      );
    },
    generateTimeSeriesReport() {
      var self = this;
      self.barChartData = null;
      self.barChartOptions = null;

      //Modify data to count based on the day of the subscription from reportData
      const result = self.reportData.reduce((acc, curr) => {
        const date = curr.transactionCreated.split("T")[0];
        const key = `${curr.subscription} - ${date}`;

        if (!acc[key]) {
          acc[key] = 0;
        }
        acc[key] += 1;

        return acc;
      }, {});
      const completeResult = {};

      const getDatesInRange = (startDate, endDate) => {
        const dates = [];
        let currentDate = startDate;
        while (currentDate <= endDate) {
          dates.push(new Date(currentDate));
          currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
      };
      //remove referense from self.fromDate
      var newFromDate = new Date(self.fromDate);
      const dateRange = getDatesInRange(newFromDate, self.toDate);
      const subscriptions = [
        ...new Set(self.reportData.map((item) => item.subscription)),
      ];

      subscriptions.forEach((subscription) => {
        dateRange.forEach((date) => {
          const dateString = date.toISOString().split("T")[0];
          const key = `${subscription} - ${dateString}`;
          if (!result[key]) {
            completeResult[key] = 0;
          } else {
            completeResult[key] = result[key];
          }
        });
      });

      const formattedResult = Object.keys(completeResult).map((key) => {
        const [subscription, date] = key.split(" - ");
        return {
          subscription,
          date,
          count: completeResult[key],
        };
      });

      self.timeSeriesData = formattedResult;
      self.barChartData = {
        labels: [],
        datasets: [],
      };
      //Generate chart data for each subscription

      subscriptions.forEach((element, index) => {
        self.barChartData.datasets.push({
          label: element,
          data: [],
          backgroundColor: self.getRandomColor(
            Math.floor(Math.random() * 10000)
          ),
        });
        self.barChartData.labels = dateRange.map(
          (date) => date.toISOString().split("T")[0]
        );
        self.barChartData.datasets[index].data = formattedResult
          .filter((item) => item.subscription === element)
          .map((item) => item.count);
      });
    },
    seedRandom(seed) {
      const mask = 0xffffffff;
      let m_w = (123456789 + seed) & mask;
      let m_z = (987654321 - seed) & mask;

      return function () {
        m_z = (36969 * (m_z & 65535) + (m_z >>> 16)) & mask;
        m_w = (18000 * (m_w & 65535) + (m_w >>> 16)) & mask;
        let result = ((m_z << 16) + m_w) & mask;
        result /= 4294967296;
        result += 0.5;
        return result;
      };
    },

    getRandomColor(seed) {
      const random = this.seedRandom(seed);
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(random() * 16)];
      }
      return color;
    },
    getPieChartData() {
      var self = this;
      self.pieChartdata.labels = [
        ...new Set(self.reportData.map((item) => item.subscription)),
      ];
      self.pieChartdata.datasets = [
        {
          data: self.pieChartdata.labels.map((label) => {
            return self.reportData.filter((item) => item.subscription === label)
              .length;
          }),
          backgroundColor: self.pieChartdata.labels.map((label) =>
            self.getRandomColor(Math.floor(Math.random() * 10000))
          ),
        },
      ];
    },
    getRacePieChartData() {
      var self = this;
      self.racePieChartData.labels = [
        ...new Set(
          self.reportData.map((item) => (item.race ? item.race : "Unknown"))
        ),
      ];
      self.racePieChartData.datasets = [
        {
          data: self.racePieChartData.labels.map((label) => {
            return self.reportData.filter((item) => {
              if (item.race === label) {
                return true;
              }
              if (!item.race) {
                return label === "Unknown";
              }
            }).length;
          }),
          backgroundColor: self.racePieChartData.labels.map((label) =>
            self.getRandomColor(Math.floor(Math.random() * 10000))
          ),
        },
      ];
    },
    getTransactionTypeChartData() {
      var self = this;
      self.voucherPieChartData.labels = [
        ...new Set(self.reportData.map((item) => item.transactionType)),
      ];
      self.voucherPieChartData.datasets = [
        {
          data: self.voucherPieChartData.labels.map((label) => {
            return self.reportData.filter(
              (item) => item.transactionType === label
            ).length;
          }),
          backgroundColor: self.voucherPieChartData.labels.map((label) =>
            self.getRandomColor(Math.floor(Math.random() * 10000))
          ),
        },
      ];
    },
    getProvinceChartData() {
      var self = this;
      self.provincePieChartData.labels = [
        ...new Set(
          self.reportData.map((item) => {
            return item.province ? item.province : "Unknown";
          })
        ),
      ];
      self.provincePieChartData.datasets = [
        {
          data: self.provincePieChartData.labels.map((label) => {
            return self.reportData.filter((item) => {
              if (item.province === label) {
                return true;
              }
              if (!item.province) {
                return label === "Unknown";
              }
            }).length;
          }),
          backgroundColor: self.provincePieChartData.labels.map((label) =>
            self.getRandomColor(Math.floor(Math.random() * 10000))
          ),
        },
      ];
    },
    getVerifiedUsersChartData() {
      var self = this;
      //0 or null = false, 1 = true
      self.verifiedUsersPieChartData.labels = ["Verified", "Not Verified"];
      self.verifiedUsersPieChartData.datasets = [
        {
          data: [
            self.reportData.filter((item) => item.verified === 1).length,
            self.reportData.filter((item) => !item.verified).length,
          ],
          backgroundColor: ["#00ff00", "#ff0000"],
        },
      ];
    },
    getRegistrationPieChartData() {
      var self = this;
      self.registrationPieChartData.labels = [
        ...new Set(
          self.reportData.map((item) => {
            return item.registrationUrl ? item.registrationUrl : "Unknown";
          })
        ),
      ];
      //sum the TransactionNet values for each registrationUrl
      self.registrationPieChartData.datasets = [
        {
          data: self.registrationPieChartData.labels.map((label) => {
            // Create a map to store unique transactions
            const uniqueTransactions = new Map();

            self.reportData.forEach((item) => {
              if (
                item.registrationUrl === label ||
                (!item.registrationUrl && label === "Unknown")
              ) {
                if (!uniqueTransactions.has(item.transactionId)) {
                  uniqueTransactions.set(
                    item.transactionId,
                    item.transactionNet
                  );
                }
              }
            });
            // Sum the TransactionNet values of unique transactions
            const totalTransactionNet = Array.from(
              uniqueTransactions.values()
            ).reduce((sum, transactionNet) => sum + transactionNet, 0);
            //limit to 2 decimals
            return totalTransactionNet.toFixed(2);
          }),
          backgroundColor: self.registrationPieChartData.labels.map((label) =>
            self.getRandomColor(Math.floor(Math.random() * 10000))
          ),
        },
      ];
    },
    dowloadReportDataCSV() {
      var self = this;
      self.isDownloading = true;
      self.showLoadingOnElement("downloadReport", 0.45, "material");

      // Convert the data array to a CSV string
      try {
        const headers = Object.keys(self.reportData[0]);

        // Create CSV content
        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += headers.join(",") + "\n";

        self.reportData.forEach((row) => {
          const values = headers.map((header) => {
            const value = row[header];
            //if value is date convert to string and format to readable date using moment
            debugger;
            if (self.isValidIsoDateString(value)) {
              return moment(value).format("YYYY-MM-DD HH:mm:ss");
            }

            return typeof value === "string"
              ? `"${value.replace(/"/g, '""')}"`
              : value;
          });
          csvContent += values.join(",") + "\n";
        });

        //Add The From and To Date to the top of the file
        csvContent += `From Date,${
          self.fromDate.toISOString().split("T")[0]
        }\n`;
        csvContent += `To Date,${self.toDate.toISOString().split("T")[0]}\n`;

        // Create a download link element
        const link = document.createElement("a");
        link.setAttribute("href", encodeURI(csvContent));
        //Generate report name based on filters and date range

        link.setAttribute("download", "data.csv");

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up by removing the link
        document.body.removeChild(link);
      } catch (error) {
        setTimeout(() => {
          self.$vs.loading.close(self.$refs.downloadReport.$el);
          self.isDownloading = false;
        }, 400);
      }
      setTimeout(() => {
        self.$vs.loading.close(self.$refs.downloadReport.$el);
        self.isDownloading = false;
      }, 400);
    },
    isValidIsoDateString(dateString) {
      const isoDatePattern =
        /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/;
      return (
        isoDatePattern.test(dateString) &&
        moment(
          dateString,
          [moment.ISO_8601, "YYYY-MM-DDTHH:mm.SS.S"],
          true
        ).isValid()
      );
    },
  },
  mounted() {
    var self = this;
    self.isMounted = true;
    self.getDomainList();
  },
};
</script>
